<template>
    <div>
        <h3>Цвет углов</h3>
        <div class="mt-1">
            <div>
                <div class="sm:hidden">
                    <select id="tabs" name="tabs" class="block w-full focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md">
                        <option v-for="tab in tabs" :key="tab.name" :selected="tab.current">{{ tab.name }}</option>
                    </select>
                </div>
                <div class="hidden sm:block">
                    <nav class="flex space-x-4" aria-label="Tabs">
                        <span v-for="tab in tabs" @click="selectTab(tab)" :key="tab.name" :class="[currentType.id === tab.id ? 'bg-gray-200 text-gray-800' : 'text-gray-600 hover:text-gray-800', 'cursor-pointer px-2 py-1 font-medium text-sm rounded-md']" :aria-current="tab.current ? 'page' : undefined">
                            {{ tab.name }}
                        </span>
                    </nav>
                </div>
            </div>

            <div v-if="currentType.id === 'basic'" class="flex mt-2">
                <div class="flex">
                    <div class="text-sm mr-2 ">Цвет центра</div>
                    <color-picker v-model:pureColor="basicCenterColor" :disableAlpha="true"/>
                </div>
                <div class="flex">
                    <div class="text-sm mr-2">Цвет границ</div>
                    <color-picker format="hex" v-model:pureColor="basicBorderColor" :disableAlpha="true"/>
                </div>
            </div>

            <div v-if="currentType.id === 'advanced'">
                <div>
                    <div class="text-sm mt-2 mb-2 font-bold">Левый верхний угол</div>
                    <div class="flex">
                        <div class="flex">
                            <div class="text-sm mr-2">Цвет центра</div>
                            <color-picker format="hex" v-model:pureColor="topLeftCenterColor" :disableAlpha="true"/>
                        </div>
                        <div class="flex">
                            <div class="text-sm mr-2">Цвет границ</div>
                            <color-picker format="hex" v-model:pureColor="topLeftBorderColor" :disableAlpha="true"/>
                        </div>
                    </div>
                </div>

                <div>
                    <div class="text-sm mt-2 mb-2 font-bold">Нижний левый угол</div>
                    <div class="flex">
                        <div class="flex">
                            <div class="text-sm mr-2">Цвет центра</div>
                            <color-picker format="hex" v-model:pureColor="bottomLeftCenterColor" :disableAlpha="true"/>
                        </div>
                        <div class="flex">
                            <div class="text-sm mr-2">Цвет границ</div>
                            <color-picker format="hex" v-model:pureColor="bottomLeftBorderColor" :disableAlpha="true"/>
                        </div>
                    </div>
                </div>

                <div>
                    <div class="text-sm mt-2 mb-2 font-bold">Верхний правый угол</div>
                    <div class="flex">
                        <div class="flex">
                            <div class="text-sm mr-2">Цвет центра</div>
                            <color-picker format="hex" v-model:pureColor="topRightCenterColor" :disableAlpha="true"/>
                        </div>
                        <div class="flex">
                            <div class="text-sm mr-2">Цвет границ</div>
                            <color-picker format="hex" v-model:pureColor="topRightBorderColor" :disableAlpha="true"/>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import {mapActions, mapState} from "pinia";
import {qrCodeFormStore} from "@/scripts/store/qr_code_form.store";
import {ColorPicker} from "vue3-colorpicker";

const tabs = [
    { name: 'Общий', current: true, id: 'basic' },
    { name: 'Раздельный', current: false, id: 'advanced' },
]

export default {
    name: "MarkersStyle",

    components: {
        ColorPicker
    },

    data() {
        return {
            tabs
        }
    },

    computed: {
        ...mapState(qrCodeFormStore, ['style']),
        currentType: {
            get() {
                return this.style.markersStyle.isBasic
                    ? this.tabs.find(tab => tab.id === 'basic')
                    : this.tabs.find(tab => tab.id === 'advanced')
            },
            set(val) {
                this.updateMarkersStyle({isBasic: val.id === 'basic'})
            }
        },

        basicCenterColor: {
            get() {
                return this.style.markersStyle.basicCenterColor
            },
            set(val) {
                this.updateMarkersStyle({basicCenterColor: val})
            }
        },

        basicBorderColor: {
            get() {
                return this.style.markersStyle.basicBorderColor
            },
            set(val) {
                this.updateMarkersStyle({basicBorderColor: val})
            }
        },

        topLeftBorderColor: {
            get() {
                return this.style.markersStyle.topLeftBorderColor
            },
            set(val) {
                this.updateMarkersStyle({topLeftBorderColor: val})
            }
        },

        topLeftCenterColor: {
            get() {
                return this.style.markersStyle.topLeftCenterColor
            },
            set(val) {
                this.updateMarkersStyle({topLeftCenterColor: val})
            }
        },

        bottomLeftBorderColor: {
            get() {
                return this.style.markersStyle.bottomLeftBorderColor
            },
            set(val) {
                this.updateMarkersStyle({bottomLeftBorderColor: val})
            }
        },

        bottomLeftCenterColor: {
            get() {
                return this.style.markersStyle.bottomLeftCenterColor
            },
            set(val) {
                this.updateMarkersStyle({bottomLeftCenterColor: val})
            }
        },

        topRightBorderColor: {
            get() {
                return this.style.markersStyle.topRightBorderColor
            },
            set(val) {
                this.updateMarkersStyle({topRightBorderColor: val})
            }
        },

        topRightCenterColor: {
            get() {
                return this.style.markersStyle.topRightCenterColor
            },
            set(val) {
                this.updateMarkersStyle({topRightCenterColor: val})
            }
        },
    },

    methods: {
        ...mapActions(qrCodeFormStore, ['updateMarkersStyle']),
        selectTab(tab) {
            this.currentType = tab
        }
    }
}
</script>

<style scoped>

</style>
